import { render, staticRenderFns } from "./AdminHomeIndex.vue?vue&type=template&id=2369558f"
import script from "./AdminHomeIndex.vue?vue&type=script&lang=js"
export * from "./AdminHomeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports